module.exports = __webpack_public_path__ + "img/3.a547a72d.jpg";